module.exports = __webpack_public_path__ + "img/3화_13(4).527c691f.jpg";